import userInput from './saveInputs/userInput';

export default (user) => `
    saveUser (user: {
        ${userInput(user)}
    }) {
        id
    }
`;
